(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9232],{

/***/ 25522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ PrivateLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _appPath__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79973);
/* harmony import */ var _authContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4191);








var PrivateLink = function(props) {
    var user = (0,_authContext__WEBPACK_IMPORTED_MODULE_5__/* .useUser */ .aF)().user;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var href = user ? props.href : _appPath__WEBPACK_IMPORTED_MODULE_4__/* .AppPath.signIn */ .j.signIn(router.asPath);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        href: href
    }));
};


/***/ }),

/***/ 90010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ AboutUsText; },
/* harmony export */   "y": function() { return /* binding */ aboutUsTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var aboutUsTitle = "Welcome to Nostwave";
var AboutUsText = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Nostwave is a time machine and social platform focused around the past and things that make us feel nostalgic."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "If old video games, movies, music, or computers bring back all your memories and feelings, it means this website is right for you!"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Join us now and experience a real journey to the past."
            })
        ]
    });
};


/***/ }),

/***/ 55513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ Avatar; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_Image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41330);
/* harmony import */ var _Avatar_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91419);
/* harmony import */ var _Avatar_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Avatar_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var colors = [
    "#7e3794",
    "#67ae3f",
    "#007bff",
    "#e55d4a",
    "#fcce09",
    "#30b378",
    "#30a4b3",
    "#343a40"
];
function usernameToColor(username) {
    var sum = 0;
    for(var i = 0; i < username.length; i++){
        sum += username.charCodeAt(i);
    }
    return colors[sum % colors.length];
}
var Avatar = function(param) {
    var src = param.src, size = param.size, username = param.username, className = param.className;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(!src), displayDefault = ref[0], setDisplayDefault = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setDisplayDefault(!src);
    }, [
        src
    ]);
    var sizeClass = size ? [
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (_Avatar_module_scss__WEBPACK_IMPORTED_MODULE_4___default().small), size === "small"),
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (_Avatar_module_scss__WEBPACK_IMPORTED_MODULE_4___default().medium), size === "medium"),
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (_Avatar_module_scss__WEBPACK_IMPORTED_MODULE_4___default().large), size === "large")
    ] : [];
    if (displayDefault) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default().apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(sizeClass).concat([
                className
            ])),
            viewBox: "0, 0, 100, 100",
            width: "100%",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    cx: "50",
                    cy: "50",
                    r: "49",
                    fill: usernameToColor(username)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("text", {
                    x: "50",
                    y: "71.5",
                    fontSize: "60",
                    textAnchor: "middle",
                    fill: "#fff",
                    children: username[0].toUpperCase()
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Image__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default().apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(sizeClass).concat([
            "img-cover",
            className
        ])),
        src: src,
        alt: username + " avatar",
        onError: function() {
            return setDisplayDefault(true);
        },
        roundedCircle: true,
        fluid: true
    });
};


/***/ }),

/***/ 19232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./main/utils/seoUtils.ts
var seoUtils = __webpack_require__(24820);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/index.mjs
var free_brands_svg_icons = __webpack_require__(93024);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(99603);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./appPath.ts
var appPath = __webpack_require__(79973);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 6 modules
var Modal = __webpack_require__(6212);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./main/components/AboutUsText.tsx
var AboutUsText = __webpack_require__(90010);
;// CONCATENATED MODULE: ./main/modals/AboutUsModal.tsx




var AboutUsModal = function(param) {
    var show = param.show, onHide = param.onHide;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        show: show,
        onHide: onHide,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Title */.Z.Title, {
                    children: AboutUsText/* aboutUsTitle */.y
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsText/* AboutUsText */.w, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Footer */.Z.Footer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "primary",
                    onClick: onHide,
                    children: "Close"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./main/components/NostwaveLogo.tsx
var NostwaveLogo = __webpack_require__(83061);
// EXTERNAL MODULE: ./main/components/navigation/AppFooter.module.scss
var AppFooter_module = __webpack_require__(83367);
var AppFooter_module_default = /*#__PURE__*/__webpack_require__.n(AppFooter_module);
;// CONCATENATED MODULE: ./main/components/navigation/AppFooter.tsx










var year = new Date().getFullYear();
var AppFooter = function() {
    var ref = (0,react.useState)(false), showAboutUs = ref[0], setShowAboutUs = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsModal, {
                show: showAboutUs,
                onHide: function() {
                    return setShowAboutUs(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                className: (AppFooter_module_default()).footer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    className: "".concat((AppFooter_module_default()).container, " clearfix"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex flex-row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((AppFooter_module_default()).summary, " pe-2"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NostwaveLogo/* NostwaveLogo */.B, {
                                            link: "/",
                                            size: "6rem"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
                                            className: "mt-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Sometimes you will never know the value of a moment until it becomes a memory."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                                                    className: "blockquote-footer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("cite", {
                                                        title: "Theodor Seuss Geisel",
                                                        children: "Theodor Seuss Geisel"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (AppFooter_module_default())["social-links"],
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    target: "_blank",
                                                    rel: "noopener",
                                                    href: "https://www.youtube.com/channel/UCziEnrtdwiMFTBaIkf-st1Q",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        className: "icon-youtube",
                                                        icon: free_brands_svg_icons/* faYoutube */.opf,
                                                        fixedWidth: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    target: "_blank",
                                                    rel: "noopener",
                                                    href: "https://www.facebook.com/nostwaveofficial/",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        className: "icon-facebook",
                                                        icon: free_brands_svg_icons/* faFacebook */.neY,
                                                        fixedWidth: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    target: "_blank",
                                                    rel: "noopener",
                                                    href: "https://www.instagram.com/nostwaveofficial/",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        className: "icon-instagram",
                                                        icon: free_brands_svg_icons/* faInstagram */.Zzi,
                                                        fixedWidth: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    target: "_blank",
                                                    rel: "noopener",
                                                    href: "https://twitter.com/nostwave",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        className: "icon-twitter",
                                                        icon: free_brands_svg_icons/* faTwitter */.mdU,
                                                        fixedWidth: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    target: "_blank",
                                                    rel: "noopener",
                                                    href: "https://www.tiktok.com/@nostwave",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_brands_svg_icons/* faTiktok */.ABo,
                                                        fixedWidth: true
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "d-grid gap-2 mx-2 mx-sm-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "fw-bold",
                                                children: "Quick links"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "clickable",
                                                onClick: function() {
                                                    return setShowAboutUs(true);
                                                },
                                                children: "About us"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: appPath/* AppPath.popularTopics */.j.popularTopics,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: "Popular topics"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: appPath/* AppPath.support */.j.support,
                                                passHref: true,
                                                prefetch: false,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: "Support"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: appPath/* AppPath.termsAndConditions */.j.termsAndConditions,
                                                passHref: true,
                                                prefetch: false,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: "Terms and conditions"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: appPath/* AppPath.privacyPolicy */.j.privacyPolicy,
                                                passHref: true,
                                                prefetch: false,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: "Privacy"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                            className: "my-4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                "\xa9 ",
                                year,
                                " Nostwave. All rights reserved."
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./main/components/navigation/AppNavbar.module.scss
var AppNavbar_module = __webpack_require__(20762);
var AppNavbar_module_default = /*#__PURE__*/__webpack_require__.n(AppNavbar_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(59417);
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/exports.js
var esm_exports = __webpack_require__(92876);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Nav.js + 1 modules
var Nav = __webpack_require__(88819);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Navbar.js + 13 modules
var Navbar = __webpack_require__(15738);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/NavDropdown.js
var NavDropdown = __webpack_require__(24214);
// EXTERNAL MODULE: ./auth/authContext.ts + 1 modules
var authContext = __webpack_require__(4191);
// EXTERNAL MODULE: ./auth/components/PrivateLink.tsx
var PrivateLink = __webpack_require__(25522);
// EXTERNAL MODULE: ./auth/services/authService.ts
var authService = __webpack_require__(59458);
// EXTERNAL MODULE: ./main/hooks/useYear.ts
var useYear = __webpack_require__(29859);
// EXTERNAL MODULE: ./main/components/Avatar.tsx
var Avatar = __webpack_require__(55513);
// EXTERNAL MODULE: ./node_modules/@sentry/react/esm/errorboundary.js
var errorboundary = __webpack_require__(24975);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(36968);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./posts/models/views/topicView.ts + 1 modules
var topicView = __webpack_require__(80016);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
;// CONCATENATED MODULE: ./main/services/searchService.ts




var SearchService = /*#__PURE__*/ function() {
    "use strict";
    function SearchService() {
        (0,_class_call_check/* default */.Z)(this, SearchService);
    }
    var _proto = SearchService.prototype;
    _proto.search = function search(cancelToken, epochStartingYear, query) {
        return (0,_async_to_generator/* default */.Z)(function() {
            var _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            axios_default().get("search/".concat(epochStartingYear), (_tmp.params = {
                                query: query
                            }, _tmp.cancelToken = cancelToken, _tmp))
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        })();
    };
    return SearchService;
}();
var searchService = new SearchService();

// EXTERNAL MODULE: ./main/utils/globalConst.ts
var globalConst = __webpack_require__(52806);
// EXTERNAL MODULE: ./main/utils/timeMachineUtils.ts
var timeMachineUtils = __webpack_require__(98852);
// EXTERNAL MODULE: ./main/components/SearchBox.module.scss
var SearchBox_module = __webpack_require__(35642);
var SearchBox_module_default = /*#__PURE__*/__webpack_require__.n(SearchBox_module);
;// CONCATENATED MODULE: ./main/components/SearchBox.tsx



















var textClass = "small text-secondary";
var linkClass = "d-block w-100";
var SearchBox = function() {
    var handleChange = function handleChange(event) {
        if (requestCancelToken) {
            requestCancelToken.cancel();
        }
        setIsLoading(false);
        stopTimer();
        setValue(event.target.value);
        var query = event.target.value.trim();
        if (query.length <= 2) {
            setShowResults(false);
            return;
        }
        if (query.length > 2) {
            timer.current = setTimeout(function() {
                return search(query);
            }, globalConst/* SEARCH_DELAY */.F2);
        }
    };
    var handleKeyDown = function handleKeyDown(event) {
        if (event.key === "Enter" && !showResults) {
            var query = value.trim();
            if (query.length > 2) {
                if (result.query !== query) {
                    search(query);
                } else {
                    setShowResults(true);
                }
            }
        }
    };
    var stopTimer = function stopTimer() {
        if (timer && timer.current) {
            clearTimeout(timer.current);
            timer.current = null;
        }
    };
    var renderUser = function renderUser(user) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "text-truncate mt-2",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: appPath/* AppPath.userProfile */.j.userProfile(year, user.username),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: linkClass,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                            src: user.avatarUrl,
                            size: "small",
                            username: user.username,
                            className: "me-2"
                        }),
                        user.username
                    ]
                })
            })
        }, user.username);
    };
    var clear = function clear() {
        setValue("");
        setShowResults(false);
    };
    var renderIcon = function renderIcon() {
        if (isLoading) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                as: "span",
                animation: "border",
                size: "sm",
                role: "status",
                "aria-hidden": "true"
            });
        }
        if (value) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                className: "clickable",
                onClick: clear,
                icon: free_solid_svg_icons/* faTimes */.NBC,
                fixedWidth: true
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
            icon: free_solid_svg_icons/* faSearch */.wn1,
            fixedWidth: true
        });
    };
    var year = (0,useYear/* useYear */.V)();
    var epochStartingYear = (0,es/* useSelector */.v9)(timeMachineUtils/* getEpochStartingYear */.D9);
    var ref = (0,react.useState)(false), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,react.useState)(""), value = ref1[0], setValue = ref1[1];
    var ref2 = (0,react.useState)(null), requestCancelToken = ref2[0], setRequestCancelToken = ref2[1];
    var ref3 = (0,react.useState)(false), showResults = ref3[0], setShowResults = ref3[1];
    var ref4 = (0,react.useState)(), result = ref4[0], setResult = ref4[1];
    var inputRef = (0,react.useRef)();
    var timer = (0,react.useRef)();
    (0,react.useEffect)(function() {
        return stopTimer;
    }, []);
    function search(query) {
        return _search.apply(this, arguments);
    }
    function _search() {
        _search = (0,_async_to_generator/* default */.Z)(function(query) {
            var cancelTokenSource, data, _tmp, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        cancelTokenSource = axios_default().CancelToken.source();
                        setRequestCancelToken(cancelTokenSource);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            searchService.search(cancelTokenSource.token, epochStartingYear, query)
                        ];
                    case 2:
                        data = _state.sent().data;
                        data.users = data.users.sort(function(a, b) {
                            return a.username.localeCompare(b.username);
                        });
                        data.topics = data.topics.sort(function(a, b) {
                            return a.name.localeCompare(b.name);
                        });
                        _tmp = {};
                        setResult((_tmp.query = query, _tmp.data = data, _tmp));
                        setShowResults(true);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        setShowResults(false);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setRequestCancelToken(null);
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return _search.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SearchBox_module_default())["search-box"],
        children: [
            showResults && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setShowResults(false);
                },
                className: (SearchBox_module_default())["results-overlay"]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: function() {
                    return inputRef.current.focus();
                },
                className: "".concat((SearchBox_module_default())["search-pill"], " rounded-pill shadow-sm py-1 px-3 bg-light"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SearchBox_module_default())["search-status-icon"],
                        children: renderIcon()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        ref: inputRef,
                        value: value,
                        maxLength: globalConst/* SEARCH_QUERY_MAX_LENGTH */.f3,
                        onChange: handleChange,
                        onKeyDown: handleKeyDown,
                        className: "p-0 bg-light",
                        type: "text",
                        placeholder: "Search..."
                    })
                ]
            }),
            showResults && !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((SearchBox_module_default()).resultsContainer, " w-100 bg-white position-absolute shadow-sm border-bottom"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((SearchBox_module_default()).results, " px-3 pb-3 text-body"),
                    children: [
                        result.data.users.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: textClass,
                                    children: "Users"
                                }),
                                result.data.users.map(function(i) {
                                    return renderUser(i);
                                })
                            ]
                        }),
                        result.data.users.length > 0 && result.data.topics.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                        result.data.users.length === 0 && result.data.topics.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: textClass,
                            children: "No results :("
                        }),
                        result.data.topics.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: textClass,
                                    children: "Topics"
                                }),
                                result.data.topics.map(function(i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-2 text-truncate",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: appPath/* AppPath.topic */.j.topic(i),
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                className: linkClass,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: i.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "topic-subtitle",
                                                        children: [
                                                            topicView/* topicNameMap */.Z[i.category],
                                                            " (",
                                                            i.year,
                                                            ")"
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }, i.id);
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
SearchBox = (0,errorboundary/* withErrorBoundary */.Pf)(SearchBox, {
    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
});


;// CONCATENATED MODULE: ./main/components/navigation/MainNavbar.tsx





















var MainNavbar = function() {
    var ref = (0,authContext/* useUser */.aF)(), user = ref.user, signOut = ref.signOut;
    var router = (0,next_router.useRouter)();
    var year = (0,useYear/* useYear */.V)();
    function handleSignOut() {
        return _handleSignOut.apply(this, arguments);
    }
    function _handleSignOut() {
        _handleSignOut = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (router.asPath !== "/") {
                    router.replace("/");
                }
                authService/* authService.signOut */.O.signOut().catch(function(error) {
                    esm_exports/* captureException */.Tb(error);
                });
                signOut();
                return [
                    2
                ];
            });
        });
        return _handleSignOut.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {
        className: "navbar-light border-bottom",
        bg: "white",
        expand: "lg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default.Brand */.Z.Brand, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NostwaveLogo/* NostwaveLogo */.B, {
                        link: "/",
                        size: "6rem"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default.Toggle */.Z.Toggle, {
                    "aria-controls": "basic-navbar-nav"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navbar/* default.Collapse */.Z.Collapse, {
                    id: "basic-navbar-nav",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.Z, {
                            className: "pt-3 pt-lg-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBox, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "pt-3 pt-lg-0 ms-2 d-flex align-items-center flex-grow-1 justify-content-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivateLink/* PrivateLink */.C, {
                                        href: appPath/* AppPath.writePost */.j.writePost,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "nav-link",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    className: "me-1",
                                                    icon: free_solid_svg_icons/* faPencilAlt */.UJf
                                                }),
                                                " Write"
                                            ]
                                        })
                                    })
                                }),
                                user && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex flex-row align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.Z, {
                                            className: "clickable",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: appPath/* AppPath.userProfile */.j.userProfile(year, user.username),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    className: "d-inline-flex align-items-center nav-link",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                                                            src: user.avatarUrls[year],
                                                            size: "small",
                                                            username: user.username
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "ms-2",
                                                            children: user.username
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavDropdown/* default */.Z, {
                                            title: "",
                                            id: "user-dropdown",
                                            align: "end",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDropdown/* default.Item */.Z.Item, {
                                                    href: appPath/* AppPath.userProfile */.j.userProfile(year, user.username),
                                                    children: "See your profile"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDropdown/* default.Item */.Z.Item, {
                                                    href: appPath/* AppPath.accountSettings */.j.accountSettings,
                                                    children: "Settings"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDropdown/* default.Divider */.Z.Divider, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDropdown/* default.Item */.Z.Item, {
                                                    onClick: handleSignOut,
                                                    children: "Sign out"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                !user && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.Z, {
                                            className: "ms-auto",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Link */.Z.Link, {
                                                as: (link_default()),
                                                href: appPath/* AppPath.signIn */.j.signIn(),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "nav-link",
                                                    children: "Sign in"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.Z, {
                                            className: "ms-3 ms-lg-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Link */.Z.Link, {
                                                as: (link_default()),
                                                href: appPath/* AppPath.signUp */.j.signUp,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "nav-link",
                                                    children: "Sign up"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./main/components/navigation/TimeMachineNavbar.module.scss
var TimeMachineNavbar_module = __webpack_require__(83088);
var TimeMachineNavbar_module_default = /*#__PURE__*/__webpack_require__.n(TimeMachineNavbar_module);
;// CONCATENATED MODULE: ./main/components/navigation/TimeMachineNavbar.tsx












var epochs = timeMachineUtils/* epochStartingYears.map */.Qr.map(function(i) {
    return {
        id: i,
        name: (0,timeMachineUtils/* getEpochText */.n1)(i)
    };
});
var TimeMachineNavbar = function() {
    var scroll = // TODO animate
    function scroll(value) {
        yearsList.current.scrollLeft += value;
    };
    var renderYear = function renderYear(epoch, index) {
        var active = epoch.id === year;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: router.asPath.replace("/".concat(year, "/"), "/".concat(epoch.id, "/")),
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: classnames_default()("mx-2 clickable", active ? "text-primary fw-bold" : "text-secondary"),
                    children: epoch.name
                })
            })
        }, index);
    };
    var yearsList = (0,react.useRef)();
    var router = (0,next_router.useRouter)();
    var year = (0,useYear/* useYear */.V)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {
        className: "".concat((TimeMachineNavbar_module_default())["navbar-tm"], " navbar-light border-bottom"),
        bg: "white",
        expand: "lg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "d-flex flex-row text-nowrap mw-100",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pe-3",
                        children: "Time machine"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((TimeMachineNavbar_module_default()).scroller, " text-secondary pe-1"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            className: "clickable",
                            icon: free_solid_svg_icons/* faChevronLeft */.A35,
                            fixedWidth: true,
                            onClick: function() {
                                return scroll(-100);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: yearsList,
                        className: "".concat((TimeMachineNavbar_module_default()).epochs, " hide-scrollbar bullets"),
                        children: epochs.map(renderYear)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((TimeMachineNavbar_module_default()).scroller, " text-secondary ps-1"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            className: "clickable",
                            icon: free_solid_svg_icons/* faChevronRight */._tD,
                            fixedWidth: true,
                            onClick: function() {
                                return scroll(100);
                            }
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./main/components/navigation/AppNavbar.tsx




var AppNavbar = function(param) {
    var noTimeMachineNav = param.noTimeMachineNav;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((AppNavbar_module_default())["nav-shadow"], " mb-4 sticky-top"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainNavbar, {}),
            !noTimeMachineNav && /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeMachineNavbar, {})
        ]
    });
};

;// CONCATENATED MODULE: ./main/components/Layout.tsx







var Layout = function(param) {
    var children = param.children, title = param.title, description = param.description, openGraph = param.openGraph, noNavigation = param.noNavigation, noIndex = param.noIndex, noArchive = param.noArchive, noTimeMachineNav = param.noTimeMachineNav, noTitleSuffix = param.noTitleSuffix, fullPage = param.fullPage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: title + (noTitleSuffix ? "" : seoUtils/* titleSuffix */._F),
                defaultTitle: "Nostwave",
                description: description,
                noindex: Boolean(noIndex),
                robotsProps: {
                    noarchive: Boolean(noArchive)
                },
                openGraph: {
                    type: openGraph && openGraph.type || "article",
                    title: title,
                    description: description,
                    site_name: "Nostwave",
                    profile: openGraph && openGraph.profile ? {
                        username: openGraph.profile.username
                    } : null
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "d-flex flex-column min-vh-100",
                children: [
                    !noNavigation && /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppNavbar, {
                            noTimeMachineNav: noTimeMachineNav
                        })
                    }),
                    fullPage ? children : /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        className: "flex-grow-1",
                        children: children
                    }),
                    !noNavigation && /*#__PURE__*/ (0,jsx_runtime.jsx)(AppFooter, {})
                ]
            })
        ]
    });
};


/***/ }),

/***/ 29859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useYear; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_timeMachineUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98852);


function useYear() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    if (router.query.year) {
        return +router.query.year;
    }
    return _utils_timeMachineUtils__WEBPACK_IMPORTED_MODULE_1__/* .epochStartingYears[0] */ .Qr[0];
}


/***/ }),

/***/ 24820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_F": function() { return /* binding */ titleSuffix; },
/* harmony export */   "aF": function() { return /* binding */ truncateText; },
/* harmony export */   "ew": function() { return /* binding */ truncateTitle; },
/* harmony export */   "zA": function() { return /* binding */ yearsFromToText; }
/* harmony export */ });
/* harmony import */ var lodash_truncate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31373);
/* harmony import */ var lodash_truncate__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_truncate__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _globalConst__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52806);
/* harmony import */ var _timeMachineUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98852);



var titleSuffix = " | Nostwave";
function truncateTitle(text) {
    return truncateText(text, _globalConst__WEBPACK_IMPORTED_MODULE_2__/* .META_TITLE_MAX_LENGTH */ .tx);
}
function truncateText(text) {
    var maxLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _globalConst__WEBPACK_IMPORTED_MODULE_2__/* .META_DESC_MAX_LENGTH */ .Fs;
    return lodash_truncate__WEBPACK_IMPORTED_MODULE_0___default()(text, {
        length: maxLength,
        separator: " "
    });
}
function yearsFromToText(year) {
    return "years ".concat(year, "-").concat((0,_timeMachineUtils__WEBPACK_IMPORTED_MODULE_1__/* .getEpochEndingYear */ .MC)(year));
}


/***/ }),

/***/ 98852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D9": function() { return /* binding */ getEpochStartingYear; },
/* harmony export */   "MC": function() { return /* binding */ getEpochEndingYear; },
/* harmony export */   "Qr": function() { return /* binding */ epochStartingYears; },
/* harmony export */   "dx": function() { return /* binding */ defaultEpochStartingYear; },
/* harmony export */   "n1": function() { return /* binding */ getEpochText; }
/* harmony export */ });
var epochStartingYears = [
    2021,
    2016,
    2011,
    2006,
    2001,
    1996,
    1991,
    1986,
    1981,
    1976,
    1970
];
var endingYears = {
    2021: 2025,
    2016: 2020,
    2011: 2015,
    2006: 2010,
    2001: 2005,
    1996: 2000,
    1991: 1995,
    1986: 1990,
    1981: 1985,
    1976: 1980,
    1970: 1975
};
var defaultEpochStartingYear = 2021;
function getEpochEndingYear(start) {
    return endingYears[start] || -1;
}
function getEpochText(start) {
    return start + "-" + getEpochEndingYear(start);
}
function getEpochStartingYear(year) {
    if (year >= 1970 && year <= 1975) {
        return 1970;
    }
    for(var i = 1976; i < 2050; i += 5){
        if (year >= i && year <= i + 4) {
            return i;
        }
    }
    return defaultEpochStartingYear;
}


/***/ }),

/***/ 80016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ TopicView; },
  "Z": function() { return /* binding */ topicNameMap; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 5 modules
var _create_super = __webpack_require__(16567);
;// CONCATENATED MODULE: ./topics/models/topicDto.ts

var TopicDto = function TopicDto() {
    "use strict";
    (0,_class_call_check/* default */.Z)(this, TopicDto);
};

// EXTERNAL MODULE: ./posts/models/enums/topicCategory.ts
var topicCategory = __webpack_require__(90766);
;// CONCATENATED MODULE: ./posts/models/views/topicView.ts






var _obj;
var topicNameMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, topicCategory/* TopicCategory.VideoGame */.t.VideoGame, "Video game"), (0,_define_property/* default */.Z)(_obj, topicCategory/* TopicCategory.Movie */.t.Movie, "Movie"), (0,_define_property/* default */.Z)(_obj, topicCategory/* TopicCategory.Music */.t.Music, "Music"), (0,_define_property/* default */.Z)(_obj, topicCategory/* TopicCategory.TvSeries */.t.TvSeries, "TV Series"), (0,_define_property/* default */.Z)(_obj, topicCategory/* TopicCategory.Book */.t.Book, "Book"), (0,_define_property/* default */.Z)(_obj, topicCategory/* TopicCategory.Company */.t.Company, "Company"), (0,_define_property/* default */.Z)(_obj, topicCategory/* TopicCategory.CPU */.t.CPU, "Processor (CPU)"), (0,_define_property/* default */.Z)(_obj, topicCategory/* TopicCategory.GPU */.t.GPU, "Graphics card (GPU)"), (0,_define_property/* default */.Z)(_obj, topicCategory/* TopicCategory.MobileDevice */.t.MobileDevice, "Mobile device"), (0,_define_property/* default */.Z)(_obj, topicCategory/* TopicCategory.VideoGameConsole */.t.VideoGameConsole, "Video Game Console"), (0,_define_property/* default */.Z)(_obj, topicCategory/* TopicCategory.Computer */.t.Computer, "Computer"), (0,_define_property/* default */.Z)(_obj, topicCategory/* TopicCategory.OS */.t.OS, "Operating System"), (0,_define_property/* default */.Z)(_obj, topicCategory/* TopicCategory.Software */.t.Software, "Software"), (0,_define_property/* default */.Z)(_obj, topicCategory/* TopicCategory.Person */.t.Person, "Person"), (0,_define_property/* default */.Z)(_obj, topicCategory/* TopicCategory.Country */.t.Country, "Country"), (0,_define_property/* default */.Z)(_obj, topicCategory/* TopicCategory.Football */.t.Football, "Football"), _obj);
var TopicView = /*#__PURE__*/ function(TopicDto) {
    "use strict";
    (0,_inherits/* default */.Z)(TopicView, TopicDto);
    var _super = (0,_create_super/* default */.Z)(TopicView);
    function TopicView() {
        (0,_class_call_check/* default */.Z)(this, TopicView);
        return _super.apply(this, arguments);
    }
    TopicView.categoryName = function categoryName(dto) {
        return topicNameMap[dto.category];
    };
    return TopicView;
}(TopicDto);


/***/ }),

/***/ 91419:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"small":"Avatar_small__N_nJ2","medium":"Avatar_medium__VaEH9","large":"Avatar_large__7IF_k"};

/***/ }),

/***/ 35642:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search-box":"SearchBox_search-box__JbIK4","results-overlay":"SearchBox_results-overlay__IrF3R","search-pill":"SearchBox_search-pill__8b34a","resultsContainer":"SearchBox_resultsContainer__uPx6M","results":"SearchBox_results__Yeaay","search-status-icon":"SearchBox_search-status-icon__3G4xL"};

/***/ }),

/***/ 83367:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"AppFooter_footer__58G2v","container":"AppFooter_container__aYrL_","summary":"AppFooter_summary__MHvMu","social-links":"AppFooter_social-links__d4npE"};

/***/ }),

/***/ 20762:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nav-shadow":"AppNavbar_nav-shadow__WO8_X"};

/***/ }),

/***/ 83088:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navbar-tm":"TimeMachineNavbar_navbar-tm__zIXR1","scroller":"TimeMachineNavbar_scroller__BeKXg","epochs":"TimeMachineNavbar_epochs__Bc676"};

/***/ })

}]);